import type { ReactNode } from 'react';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { LineupCount } from 'atoms/icons/LineupCount';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyS, LabelM } from 'atoms/typography';
import { Ellipsis } from 'atoms/typography/Ellipsis';

const Root = styled(Horizontal)`
  width: 100%;
`;

type Props = {
  badge?: ReactNode;
  leaderboardName: string;
  action?: ReactNode;
  extra?: ReactNode;
  label?: ReactNode;
  lineupCount?: number;
  showLiveDot?: boolean;
  small?: boolean;
};

export const LineupHeader = ({
  badge,
  leaderboardName,
  action,
  extra,
  label,
  lineupCount,
  showLiveDot,
  small,
}: Props) => {
  if (!leaderboardName) {
    return <Root />;
  }

  const MainText = small ? LabelM : BodyS;

  return (
    <Root gap={1}>
      {badge}
      <Horizontal>
        <Vertical gap={0}>
          <Horizontal gap={0.5}>
            <MainText as="h3" bold color="var(--c-white)">
              <Ellipsis>{leaderboardName}</Ellipsis>
            </MainText>
            {action}
            {extra}
          </Horizontal>
          <Horizontal gap={0.5}>
            {!!label && <LabelM>{label}</LabelM>}
            {typeof lineupCount === 'number' && (
              <>
                {!!showLiveDot && (
                  <svg
                    viewBox="0 0 2 2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="2.5"
                  >
                    <circle cx="1" cy="1" r="1" fill="var(--c-nd-600)" />
                  </svg>
                )}
                <Horizontal gap={0.5}>
                  <LineupCount fill="var(--c-nd-600)" />
                  <LabelM color="var(--c-nd-600)">
                    <FormattedNumber value={lineupCount} />
                  </LabelM>
                </Horizontal>
              </>
            )}
          </Horizontal>
        </Vertical>
      </Horizontal>
    </Root>
  );
};
